import { PostgrestError } from '@supabase/supabase-js';

/** Postgres SQLSTATE for "duplicate key value violates unique constraint". */
export const UNIQUE_VIOLATION = '23505';

export function isPostgrestError(error: unknown): error is PostgrestError {
  return typeof error === 'object' && error !== null && 'code' in error && 'message' in error;
}

/**
 * True when `error` is a unique-constraint violation, optionally narrowed to one
 * constraint by name. Postgres names the constraint in the message/details, which
 * is the only way to tell two unique rules on the same table apart.
 */
export function isUniqueViolation(error: unknown, constraint?: string): boolean {
  if (!isPostgrestError(error) || error.code !== UNIQUE_VIOLATION) return false;
  if (!constraint) return true;
  return `${error.message} ${error.details ?? ''}`.includes(constraint);
}
